import { ReactNode, useRef, useState } from 'react';
import { Tooltip, TooltipProps } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';

type OverflowTooltipProps = TooltipProps & {
  tooltipValue: ReactNode;
  lines?: number;
};

export const OverflowTooltip: BFC<OverflowTooltipProps> = ({
  children,
  tooltipValue,
  lines = 1,
  className,
  ...props
}) => {
  const { overlayInnerStyle } = props;
  const [title, setTitle] = useState<ReactNode | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    const el = ref.current;
    if (!el) return;
    const overflow = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    setTitle(overflow ? tooltipValue : null);
  };

  return (
    <Tooltip
      {...props}
      overlayInnerStyle={{
        color: COLORS.systemDark300,
        ...overlayInnerStyle,
      }}
      color={COLORS.systemLight100}
      title={title}
      className={className}
    >
      <Inner
        style={{
          WebkitLineClamp: lines,
        }}
        ref={ref}
        onMouseEnter={handleMouseEnter}
      >
        {children}
      </Inner>
    </Tooltip>
  );
};

const Inner = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;
